/**
 * View builder for the variant selector used on the product pricing page.
 *
 * data-sw-variant-dropdown=<spin>
 */

module.exports = function($fragment) {

  require([
    'js/lib/models/ModelManager',
    'js/lib/views/VariantDropdownView',
    'js/sw-jquery/sw-jquery'
  ], function(ModelManager, VariantDropdownView, $) {

  $fragment.swFindWithSelf('[data-sw-variant-dropdown]').each(function() {
    var $el = $(this);
    var spin = $el.data('swVariantDropdown');

    new VariantDropdownView({
      el:     $el,
      model:  ModelManager.getProductEdit(spin)
    });
  });

  });
};
